import * as React from "react";
import Link from "next/link";
import Image from "next/image";
import { IoMenu, IoClose } from "react-icons/io5"; // Icons for menu toggle
import { useRouter } from "next/router"; // Import useRouter hook
import logo from "../../public/logo.svg";
import Button from "components/button/Button";
import useAuth from "hooks/auth/useAuth";

const pages = [
  { title: "Գլխավոր", value: "/" },
  { title: "Կանխատեսումներ", value: "/predictions" },
  { title: "Կանխատեսողներ", value: "/predictors" },
  { title: "Ընդհանրական", value: "/reversed" },
  { title: "Մեր մասին", value: "/about-us" },
];

function ResponsiveAppBar({ currentUser }) {
  const { isLoading, signOut } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const router = useRouter(); // Access the router

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const getLinkClass = (pageValue) => {
    return router.pathname.includes(pageValue)
      ? "peer py-1 text-[#0033FF] rounded-md cursor-pointer transition-all duration-500 text-[14px] font-[500] leading-1 -tracking-[0.56px]"
      : "peer py-1 bg-white rounded-md cursor-pointer hover:text-[#0033FF] transition-all duration-500 text-[14px] font-[500] leading-1";
  };

  return (
    <div style={{ fontFamily: "Noto Sans Armenian" }} className="relative">
      {/* Top bar */}
      <div className="flex justify-between items-center bg-white h-[100px] px-[20px] md:px-[124px]">
        {!router.pathname.includes("auth") && (
          <Link href="/" className="flex gap-4 items-center cursor-pointer">
            <Image
              width={0}
              height={0}
              sizes="100vh"
              src={logo}
              alt="logo"
              priority
            />
          </Link>
        )}

        {/* Desktop menu */}
        <div className="hidden xl:flex gap-[8px] items-center justify-center">
          {pages.map((page) => (
            <div
              key={page.value}
              className="flex flex-col items-center justify-center"
            >
              <Link
                className={getLinkClass(page.value)} // Apply the active class conditionally
                href={page.value}
              >
                {page.title}
              </Link>
              <div className="border border-[#0033FF] w-[20px] opacity-60 transition-all duration-500 peer-hover:w-full"></div>
            </div>
          ))}
          {!router.pathname.includes("auth") && (
            <span className="mx-[14px]">|</span>
          )}
          {!router.pathname.includes("auth") && !isLoading && !currentUser && (
            <div className="flex items-center gap-4">
              <Button
                onClick={() =>
                  router.push(
                    {
                      pathname: "/auth",
                      query: { mode: "registration" },
                    },
                    undefined,
                    { shallow: true },
                  )
                }
                variant="secondary"
              >
                <span className="text-[14px]">Գրանցվել</span>
              </Button>
              <Button
                onClick={() =>
                  router.push(
                    {
                      pathname: "/auth",
                      query: { mode: "login" },
                    },
                    undefined,
                    { shallow: true },
                  )
                }
              >
                Մուտք
              </Button>
            </div>
          )}
          {!isLoading && currentUser && (
            <div>
              <Button onClick={signOut}>Դուրս գալ</Button>
            </div>
          )}
        </div>

        {/* Mobile menu toggle button */}
        <button
          onClick={toggleMobileMenu}
          className="xl:hidden text-2xl p-2 focus:outline-none"
          title="mobile menu"
        >
          {isMobileMenuOpen ? <IoClose /> : <IoMenu />}
        </button>
      </div>

      {/* Mobile menu with animation */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center transition-transform duration-300 ${
          isMobileMenuOpen
            ? "translate-x-0 opacity-100"
            : "translate-x-full opacity-0"
        }`}
      >
        <div className="bg-white w-full h-full p-6 flex flex-col items-center gap-6">
          {/* Close button */}
          <button
            onClick={toggleMobileMenu}
            className="text-2xl self-end p-2 bg-gray-200 hover:bg-gray-300 rounded-full focus:outline-none"
            title="Close"
          >
            <IoClose />
          </button>

          {pages.map((page) => (
            <Link
              key={page.value}
              className={`text-xl text-center w-full py-3 rounded-md ${
                router.pathname === page.value
                  ? "bg-[#493ED3] text-white"
                  : "bg-gray-200 hover:bg-[#493ED3] hover:text-white"
              } transition-all duration-300`}
              href={page.value}
              onClick={toggleMobileMenu}
            >
              {page.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ResponsiveAppBar;
